import React from 'react';
import { Box } from '@mui/material';

const MessageBox = ({ type, message, height }) => {
  const getStyles = (type) => {
    switch (type) {
      case 'error':
        return {
          borderLeft: '1.5px solid #CF706F',
          backgroundColor: 'rgba(207, 112, 111, 0.10)',
          color: '#D0021B',
        };
      case 'info':
        return {
          borderLeft: '1.5px solid #1D8099',
          background: '#E9F5F8',
          color: '#1D8099',
        };
      default:
        return {};
    }
  };

  const styles = {
    borderRadius: '0px 8px 8px 0px',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    padding: '8px 16px',
    display: 'flex',  
    alignItems:'center',
    gap: '10px',
    margin: '10px 4px',
    height: height || 'auto',
    ...getStyles(type),
  };

  return (
    <Box sx={styles}>
      {message}
    </Box>
  );
};

export default MessageBox;